<template>
    <v-row>
        <v-col cols="12" class="py-0 my-0">
            <v-card-title>Firma digital</v-card-title>
        </v-col>
        <v-col cols="12" lg="6">
            <v-file-input
                v-model="fileCert"
                chips
                counter
                prepend-icon="mdi-paperclip"
                outlined
                :append-icon="fileCertUrl != '' ? 'mdi-download': ''"
                :clearable="!uploadingFile"
                :loading="uploadingFile"
                accept ="file"
                :show-size="1000"
                label="LLave pública (.cer)"
                placeholder="Selecciona un archivo con extensión .cer "
                :class="field.extra.attributes"
                :readonly="readonly"
                :rules="rules"
                @change="onUploadFile"
                @click:append="downloadFile"

            >
                <template v-slot:selection="{}">
                    <v-chip
                        :color="uploadingFile ? 'secondary': 'primary'"
                        dark
                        label
                    >
                        {{ fileCert.name }}
                    </v-chip>
                </template>
            </v-file-input>
        </v-col>
        <v-col cols="12" lg="6">
            <v-file-input
                outlined chips counter
                v-model="fileKey"
                label="LLave privada (.key)"
                placeholder="Seleccionado un archivo con extensión .key"
            >

            </v-file-input>
        </v-col>
        <v-col cols="12" lg="6" class="py-0 my-0">
            <v-text-field
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                label="* Ingresa la contraseña para tu Llave Digital"
                placeholder="Contraseña"
                @click:append="showPassword = !showPassword"
                outlined required
                v-model="ciecPassword"
            ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="py-0 my-0" >
            <v-btn
                @click="signStringWithKey()"
                color="success"
                class="mt-2"
            >
                Firmar Cadena
                <v-icon small right>fas fa-pencil-alt</v-icon>
            </v-btn>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 mt-0">
            <v-simple-table>
                <thead><tr><th colspan="2" class="text-subtitle-2 primary--text">Vista previa de la información a firmar</th></tr></thead>
                <tbody>
                    <tr v-for="row in tablePreview" :key="row.key">
                        <td class="font-weight-bold">{{row.key}}</td><td>{{row.value}}</td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-col>


        <v-col cols="12" lg="6" class="pt-0 mt-0">
            <v-textarea
                v-model="formValues['original_message']"
                label="Cadena original a firmar"
                @click:append="showRepeatPassword = !showPassword"
                outlined required
                readonly
                class="mr-2"
            ></v-textarea>
        </v-col>


        <v-col cols="12" class="pt-0 mt-0">
            <v-textarea
                v-model="formValues['signed_message']"
                label="* Cadena firmada"
                placeholder="Cadena final firmada."
                outlined
                readonly
                required
            ></v-textarea>
        </v-col>

    </v-row>

</template>

<script>
import axios from 'axios'
import procedureFormValidator from "bestgob-core/form/procedure.form.validator";
import * as Storage from 'bestgob-core/core/storage.js'

var rs = require('jsrsasign')
// eslint-disable-next-line no-unused-vars
var rsu = require('jsrsasign-util')

export default {
    name: "FirmaDigital",
    props: ['field', 'readonly', 'label', 'formValues'],

    data() {
        return {
            rules: [procedureFormValidator.file.required(this.field.validacion.required, this.readonly)],

            showPassword: false,

            tablePreview: [],
            fileKey: null,
            ciecPassword: null,
            finalSignedString: null,

            fileCert: null,
            fileCertUrl: null,
            //fileCertValue: null,
            uploadingFile: false,
        }
    },

    mounted() {
        if (this.formValues[this.field.datos.certificado.name] != null){
            this.fileCertUrl = this.field.datos.certificado.public_url
            this.fileCert = new File(["foo"], this.formValues[this.field.datos.certificado.name])

        }

        this.parseStringToTable()
    },

    methods: {
        onUploadFile(file){
            if (file != null){
                this.uploadingFile = true

                this.fileName = file.name
                this.mimeType = file.type

                this.readFile(file)
            }else {
                this.fileName = null
            }
        },

        getExtensionsAccepted(){
            let accepted = ""
            this.field.extra.filetypes.forEach((extension) => {
                accepted += `.${extension},`
            })

            return accepted.slice(0, -1)
        },

        readFile(file){
            let reader = new FileReader()
            reader.readAsArrayBuffer(file)

            reader.onload =  evt => {
                this.uploadFile(evt.target.result)
            }
        },

        uploadFile(data) {
            let token = Storage.getItem('token')
            axios.post(`${this.field.datos.certificado.upload_url}?qqfile=${this.fileCert.name}`,
                data,
                {
                    headers: {
                        "Content-Type": this.fileCert.type,
                        'Authorization': `Bearer ${token}`
                    }
                })
                .then((result) => {
                    console.log(result)
                    //this.fileName = result.data.file_name
                    this.fileCertUrl = result.data.public_url
                    this.formValues[this.field.datos.certificado.name] = result.data.value


                    this.uploadingFile = false
                })
                .catch((error) => {
                    alert("Hubo un error al intentar subir el archivo. " + error.message)
                })
        },

        downloadFile(){
            window.open(this.fileCertValue)
        },

        parseStringToTable(){
            let data = this.field.datos.final_sign_string.split('|+|')
            console.log(data)

            data.forEach(data => {
                let rowData = data.split('|=|')
                let key = rowData[0] || '-'
                let value = rowData[1] || '-'

                this.tablePreview.push({key: key, value: value})
            })
        },

        /** COdigo fuente replicado del JS de panel en Ruby y PHP GPM **/
        signStringWithKey(){
            let reader = new FileReader()
            reader.onload = () => {
                let EncKeyFile = rs.hex2b64(rs.rstrtohex(reader.result), 'Base64')

                let temp = ''
                let numberOfLines = Math.ceil(EncKeyFile.length/64)
                let step = null

                for (let cont = numberOfLines; cont >0; cont --){
                    step = (numberOfLines-cont) *64
                    temp = temp + EncKeyFile.substr(step, 64) + "\n"
                }

                EncKeyFile = temp
                let archivoKeyEncryptadoPEM = '-----BEGIN ENCRYPTED PRIVATE KEY-----\n'+EncKeyFile+'-----END ENCRYPTED PRIVATE KEY-----';
                let signedMessage = ''

                try {
                    let rsaKey = rs.KEYUTIL.getKeyFromEncryptedPKCS8PEM(archivoKeyEncryptadoPEM, this.ciecPassword)
                    let signedNonHash = rsaKey.sign('hola mundo', 'sha512')
                    signedMessage = this.linebrk(signedNonHash, 64)

                    this.formValues['signed_message'] = signedMessage

                }catch (err){
                    alert('El mensaje no pudo firmarse, favor de revisar que la llave (.key) y la contraseña sean las correctas');
                }
            }

            reader.readAsBinaryString(this.fileKey)
        },

        linebrk(c,d){
            var a="";
            var b=0;
            while(b+d<c.length){
                a+=c.substring(b,b+d)+"\n";b+=d
            }
            return a+c.substring(b,c.length)
        }
        /*** Termina codigo replicado **/
    }
}
</script>